<template>
  <el-container class="layout-container">
    <!-- 修改侧边栏宽度绑定方式，添加拖拽手柄 -->
    <el-aside :width="sidebarWidth" class="layout-aside">
      <NavMenu :collapseStatus="isCollapse" />
      <!-- 拖拽手柄 -->
      <div class="resize-handle" @mousedown="startDrag"></div>
    </el-aside>
    <el-container style="min-width: 1000px">
      <el-header height="auto" class="layout-header">
        <Header @isCollapseChange="isCollapseChange" />
      </el-header>
      <slot></slot>
    </el-container>
  </el-container>
</template>

<script>
import { computed, defineComponent, ref, provide } from 'vue'

import NavMenu from './NavMenu'
import Header from './Header'

export default defineComponent({
  name: 'Container',
  components: {
    NavMenu,
    Header
  },
  setup() {
    const isCollapse = ref(false)
    // 添加侧边栏宽度变量
    const sidebarWidth = ref(isCollapse.value ? '80px' : '208px')

    const containerWidth = computed(() => {
      return `calc(100vw - ${sidebarWidth.value} - 20px)`
    })

    provide('containerProvide', {
      containerWidth
    })

    const isCollapseChange = value => {
      isCollapse.value = value
      // 同步更新宽度变量
      sidebarWidth.value = value ? '80px' : '208px'

      // requestAnimationFrame(() => {
      //   isCollapse.value = value
      //   sidebarWidth.value = value ? '80px' : '208px'
      // })
    }

    // 添加拖拽相关方法
    const startDrag = e => {
      // 记录初始位置和宽度
      const startX = e.clientX
      const startWidth = parseInt(sidebarWidth.value)
      const minWidth = 80
      const maxWidth = 330

      // 阻止文本选择
      document.body.style.userSelect = 'none'

      const handleMouseMove = e => {
        // 计算移动距离
        const deltaX = e.clientX - startX
        const newWidth = startWidth + deltaX

        // 限制宽度范围
        if (newWidth >= minWidth && newWidth <= maxWidth) {
          sidebarWidth.value = `${newWidth}px`
          // 同步更新折叠状态
          isCollapse.value = newWidth <= minWidth
        }
      }

      const handleMouseUp = () => {
        // 移除事件监听
        document.removeEventListener('mousemove', handleMouseMove)
        document.removeEventListener('mouseup', handleMouseUp)
        // 恢复文本选择
        document.body.style.userSelect = ''
      }

      // 添加事件监听
      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
    }

    return {
      isCollapse,
      sidebarWidth,
      isCollapseChange,
      startDrag
    }
  }
})
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100%;
}

.layout-aside {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 999;
  transition: width 0.2s linear 0s;
  // transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1); /* 使用更平滑的缓动函数 */
  // will-change: width; /* 提示浏览器优化动画 */
  // contain: layout paint; /* 限制重排重绘范围 */
  // overflow: hidden; /* 防止内容溢出导致额外重排 */
  position: relative;

  // 拖拽手柄样式
  .resize-handle {
    position: absolute;
    top: 0;
    right: 0;
    width: 3px;
    height: 100%;
    cursor: col-resize;
    background: transparent;

    &:hover {
      background: $primary-color;
    }
  }
}

.layout-header {
  position: relative;
  padding: 0;
}
</style>
